/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSurveyShape } from './DataSurveyShape';
import {
    DataSurveyShapeFromJSON,
    DataSurveyShapeFromJSONTyped,
    DataSurveyShapeToJSON,
    DataSurveyShapeToJSONTyped,
} from './DataSurveyShape';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Site serializer, displaying all non-relational site fields.
 * @export
 * @interface SiteRequest
 */
export interface SiteRequest {
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    siteName?: string;
    /**
     * Type of site inferred from satellite imagery
     * @type {string}
     * @memberof SiteRequest
     */
    siteTypeFromImagery?: string;
    /**
     * 
     * @type {Date}
     * @memberof SiteRequest
     */
    dateOfInstallation?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    operatorStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    subpartWSegment?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    operatorUniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    otherOperatorIds?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteRequest
     */
    owner?: number | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof SiteRequest
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {DataSurveyShape}
     * @memberof SiteRequest
     */
    shape?: DataSurveyShape | null;
    /**
     * 
     * @type {Date}
     * @memberof SiteRequest
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SiteRequest
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    siteDataSource?: string;
    /**
     * 
     * @type {any}
     * @memberof SiteRequest
     */
    extraData?: any | null;
    /**
     * 
     * @type {any}
     * @memberof SiteRequest
     */
    sensorConfig?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SiteRequest
     */
    responsiblePerson?: string | null;
}

/**
 * Check if a given object implements the SiteRequest interface.
 */
export function instanceOfSiteRequest(value: object): value is SiteRequest {
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function SiteRequestFromJSON(json: any): SiteRequest {
    return SiteRequestFromJSONTyped(json, false);
}

export function SiteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'siteName': json['site_name'] == null ? undefined : json['site_name'],
        'siteTypeFromImagery': json['site_type_from_imagery'] == null ? undefined : json['site_type_from_imagery'],
        'dateOfInstallation': json['date_of_installation'] === undefined ? undefined : json['date_of_installation'] === null ? null : (new Date(json['date_of_installation'])),
        'operatorStatus': json['operator_status'] == null ? undefined : json['operator_status'],
        'subpartWSegment': json['subpart_w_segment'] == null ? undefined : json['subpart_w_segment'],
        'operatorUniqueId': json['operator_unique_id'] == null ? undefined : json['operator_unique_id'],
        'otherOperatorIds': json['other_operator_ids'] == null ? undefined : json['other_operator_ids'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'shape': json['shape'] === undefined ? undefined : json['shape'] === null ? null : DataSurveyShapeFromJSON(json['shape']),
        'startDate': json['start_date'] === undefined ? undefined : json['start_date'] === null ? null : (new Date(json['start_date'])),
        'endDate': json['end_date'] === undefined ? undefined : json['end_date'] === null ? null : (new Date(json['end_date'])),
        'timeZone': json['time_zone'] == null ? undefined : json['time_zone'],
        'siteDataSource': json['site_data_source'] == null ? undefined : json['site_data_source'],
        'extraData': json['extra_data'] === undefined ? undefined : json['extra_data'] === null ? null : json['extra_data'],
        'sensorConfig': json['sensor_config'] === undefined ? undefined : json['sensor_config'] === null ? null : json['sensor_config'],
        'responsiblePerson': json['responsible_person'] === undefined ? undefined : json['responsible_person'] === null ? null : json['responsible_person'],
    };
}

export function SiteRequestToJSON(json: any): SiteRequest {
    return SiteRequestToJSONTyped(json, false);
}

export function SiteRequestToJSONTyped(value?: SiteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site_name': value['siteName'],
        'site_type_from_imagery': value['siteTypeFromImagery'],
        'date_of_installation': value['dateOfInstallation'] == null ? value['dateOfInstallation'] : value['dateOfInstallation'].toISOString().substring(0,10),
        'operator_status': value['operatorStatus'],
        'subpart_w_segment': value['subpartWSegment'],
        'operator_unique_id': value['operatorUniqueId'],
        'other_operator_ids': value['otherOperatorIds'],
        'owner': value['owner'],
        'location': DataPointHistoryLocationToJSON(value['location']),
        'shape': DataSurveyShapeToJSON(value['shape']),
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'time_zone': value['timeZone'],
        'site_data_source': value['siteDataSource'],
        'extra_data': value['extraData'],
        'sensor_config': value['sensorConfig'],
        'responsible_person': value['responsiblePerson'],
    };
}

